// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationNoRedirectionsPath = 'M77.032 89H87.5A10.5 10.5 0 0098 78.5V3H2v75.5A10.5 10.5 0 0012.5 89h10.443l-1.83 8.994 6.86 1.395 10.985-53.993L32.098 44l-7.73 38H12.5A3.5 3.5 0 019 78.5V27h82v51.5a3.5 3.5 0 01-3.5 3.5H75.608l-7.731-38-6.86 1.396 10.987 54.003 6.86-1.395L77.032 89zM91 20H9V10h82v10zm-79-5a3 3 0 013-3 2.9 2.9 0 013 3 3 3 0 11-6 0zm11-3a3 3 0 103 3 2.9 2.9 0 00-3-3zm8 0a3 3 0 103 3 2.9 2.9 0 00-3-3zm15 34h7v10h-7V46zm0 19h7v12h-7V65zm7 21h-7v13h7V86z';
var IllustrationNoRedirections = baseIllustration('IllustrationNoRedirections', {
  getPath: () => IllustrationNoRedirectionsPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationNoRedirections;
//# sourceMappingURL=index.js.map